<template>
  <div
    v-bind:class="classObject"
    class="d-flex justify-center items-center border border-transparent text-base leading-6 font-medium rounded-md transition ease-in-out duration-150"
  >
    <div v-if="addCharacterImg" class="mr-4" >
      <img class="h-16 md:h-20" src="/img/See-Octopus.png">
    </div>
    <svg class="animate-spin -ml-1 mr-3 h-5 w-5" v-bind:class="loadingClassObject" xmlns="http://www.w3.org/2000/svg"
         fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
    {{ loadingText }}
  </div>
</template>

<script lang="ts">

import {defineComponent} from 'vue'

export default defineComponent({
  name: 'v-loader-animation',
  props: {
    px: {
      type: String,
      default: 'px-4',
    },
    py: {
      type: String,
      default: 'py-2',
    },
    text: {
      type: String,
      default: 'text-gray-600',
    },
    loadingTextStyle: {
      type: String,
      default: 'text-black',
    },
    loadingText: {
      type: String,
      default: 'Loading',
    },
    addCharacterImg: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classObject() {

      let classObject: any = {}

      if (this.px) {
        classObject[this.px] = true
      }

      if (this.py) {
        classObject[this.py] = true
      }

      if (this.text) {
        classObject[this.text] = true
      }

      return classObject
    },
    loadingClassObject() {

      let classObject: any = {}

      if (this.loadingTextStyle) {
        classObject[this.loadingTextStyle] = true
      }

      return classObject
    }
  }

})

</script>

<style>
@media (min-width: 1024px)
.lg:px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
@media (min-width: 640px)
.sm:px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.loading .py-12 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}
.min-h-screen {
  min-height: 100vh;
}
.loading *, .loading .border {
  box-sizing: border-box !important;
  border-width: 0 !important ;
  border-style: solid !important;
  border-color: currentColor !important;
}
.loading .max-w-md {
  max-width: 28rem;
}
.loading .w-full {
  width: 100%;
}
.loading .h-16 {
  height: 4rem;
}
.loading .animate-spin {
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
}
.loading .w-5 {
  width: 1.25rem;
}
.loading .h-5 {
  height: 1.25rem;
}
.loading .items-center {
  align-items: center;
}
</style>
